<template>
  <div class="flex w-full flex-wrap items-center py-8">
    <div v-if="!isDark" class="ml-auto mr-auto">
      <img
        :src="$options.imageConfig.system.noItemDark"
        :alt="$t('components.emptyList')"
        class="h-auto w-56 sm:p-4" />
    </div>
    <div v-else class="ml-auto mr-auto">
      <img
        :src="$options.imageConfig.system.noItem"
        :alt="$t('components.emptyList')"
        class="h-auto w-56 sm:p-4" />
    </div>
    <div
      v-if="text !== undefined"
      class="w-full text-center text-xl font-semibold text-lightSystemRegularFont dark:text-darkSystemRegularFont sm:text-base">
      {{ text }}
    </div>
  </div>
</template>
<script setup lang="ts">
  import { useDark } from '@vueuse/core';

  defineProps<{
    text?: string;
  }>();

  const isDark = useDark();
</script>
